import { writable, derived } from 'svelte/store';
import type { Environment, DetailTab, ExecutionSummary, TraceNode, LogEntry, LogLevel } from '../types/debugger';
import { fetchExecutionSummary, fetchExecutionTrace, fetchLogs } from '../services/debugger-client';

export const activeTab = writable<DetailTab>('summary');
export const summary = writable<ExecutionSummary | null>(null);
export const trace = writable<TraceNode | null>(null);
export const logs = writable<LogEntry[]>([]);
export const logsFilter = writable<{ level: LogLevel | 'ALL'; search: string }>({ level: 'ALL', search: '' });
export const detailLoading = writable(false);

export const filteredLogs = derived([logs, logsFilter], ([$logs, $filter]) => {
  return $logs.filter(log => {
    if ($filter.level !== 'ALL' && log.level !== $filter.level) return false;
    if ($filter.search && !log.message.toLowerCase().includes($filter.search.toLowerCase())) return false;
    return true;
  });
});

export async function loadExecution(executionId: string, env: Environment) {
  detailLoading.set(true);
  try {
    const [s, t, l] = await Promise.all([
      fetchExecutionSummary(env, executionId),
      fetchExecutionTrace(env, executionId),
      fetchLogs(env, executionId),
    ]);
    summary.set(s);
    trace.set(t);
    logs.set(l);
  } catch (e) {
    console.error('Failed to load execution:', e);
  } finally {
    detailLoading.set(false);
  }
}
